<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
        <el-breadcrumb-item>权限列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium">            
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddUserRole" size="small" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input  placeholder="权限名称" v-model="queryParam.name" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" size="small" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="userRoles" style="width: 100%">
        <el-table-column  prop="Name"  label="名称" > </el-table-column>
        <el-table-column  prop="Type"  label="管理范围" > 
          <template slot-scope="scope">                    
            <p v-if="scope.row.Type=='0'">总部</p>
            <p v-if="scope.row.Type=='1'">代理</p>
            <p v-if="scope.row.Type=='2'">商家</p>
            <p v-if="scope.row.Type=='3'">门店</p>          
          </template>
        </el-table-column>
        <el-table-column  prop="Memo"  label="备注"> </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="EditUserRole(scope.row)"  type="text" size="small">
            编辑
          </el-button>
          <el-button @click.native.prevent="DeleteRow(scope.row)"  type="text" size="small">
            &nbsp; 删除 
          </el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        userRoles:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:'type desc',
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      AddUserRole:function(){
        this.$router.push({
          name:'userRoleInfo',
          params:{
            Id:''
          }
        })
      },
      EditUserRole:function(row){
        debugger
        if(row.IsSystem){
          this.$message.warning('超级管理员不允许编辑!');
          return;
        }
        this.$router.push({
          name:'userRoleInfo',
          params:{
            Id:row.Id,
            queryParam: this.queryParam
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/UserRole/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.userRoles = resp.data.userRoles
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      DeleteRow(row) {
        if(row.IsSystem){          
          this.$message.warning('超级管理员不允许删除!');
          return;
        }
        this.$confirm('确定要删除该权限吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/UserRole/Delete',
            data:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
        
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>